import React, { useState, useEffect } from 'react';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import backicon from './../../../../../Assets/icons/backIcon.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import axiosInstance from '../../../../services/api/API';
import Swal from 'sweetalert2';
import validations from '../../../../../helpers/validations';
import { buttonStyle, isFormValid } from '../../../../../helpers/common';

const UpdateNotification = () => {
  const authToken = localStorage.getItem('authToken');
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [StateOptions, setStateOptions] = useState([]);
  const [DealerOptions, setDealerOptions] = useState([]);
  const [editTermset, setEditTermset] = useState([]);
  const notificationId = location?.state?.data?.notificationId;
  const notificationType = location?.state?.data?.notificationType;

  //   useEffect(() => {
  //     if (
  //       formData?.notificationtype === "statewise" ||
  //       notificationType == "statewise"
  //     ) {
  //       fetchStates();
  //     } else if (
  //       formData?.notificationtype === "dealerwise" ||
  //       notificationType == "dealerwise"
  //     ) {
  //       fetchDealers();
  //     } else {
  //       setFormData({ ...formData, defaultvalue: "all" });
  //     }
  //   }, [formData?.notificationtype]);

  // useEffect(() => {
  //   if (
  //     (formData?.notificationtype === "State-Wise" ||
  //       notificationType === "State-Wise") &&
  //     StateOptions.length === 0
  //   ) {
  //     fetchStates();
  //   } else if (
  //     (formData?.notificationtype === "Dealer-Wise" ||
  //       notificationType === "Dealer-Wise") &&
  //     DealerOptions.length === 0
  //   ) {
  //     fetchDealers();
  //   } else if (
  //     formData?.notificationtype === "All" ||
  //     notificationType === "All"
  //   ) {
  //     setFormData((prevFormData) => ({ ...prevFormData, defaultvalue: "All" }));
  //   }
  // }, [formData?.notificationtype, notificationType]);

  useEffect(() => {
    if (formData?.notificationtype === 'State-Wise') {
      fetchStates();
    } else if (formData?.notificationtype === 'Dealer-Wise') {
      fetchDealers();
    } else {
      setFormData({ ...formData, defaultvalue: 'All' });
    }
  }, [formData?.notificationtype]);

  useEffect(() => {
    fetchNotification();
  }, []);

  const fetchNotification = async () => {
    try {
      const response = await axiosInstance.get(
        `/notification/edit/${notificationId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      const fetchedData = response.data.data.data[0];
      console.log('fetchedData', fetchedData);
      const formatedData = {
        notificationtype: fetchedData.notificationType,
        value_name:
          fetchedData.dealerId != 0
            ? fetchedData?.dealerId
            : fetchedData?.stateId,
        start_date: fetchedData?.startDate,
        end_date: fetchedData?.endDate,
        notificationtitle: fetchedData?.title,
        notification_desc: fetchedData?.notiDescription,
        status: fetchedData.status === 1 ? true : false,
        business_partner_id: fetchedData.business_partner_id,
        noti_image: fetchedData?.noti_image,
      };
      setFormData(formatedData);
      setEditTermset(fetchedData);
      console.log(formData, 'notificationformdata');
    } catch (error) {
      console.log(error);
    }
  };
  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post('/dealer/ddldealer', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchStates = async () => {
    try {
      const response = await axiosInstance.get('/pincodestatecity/stateList', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response?.data?.data;
      console.log(' ', data);
      const StateOptions = data.map((state) => ({
        value: state.ID,
        label: state.NAME,
      }));

      setStateOptions(StateOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const NotificationInputs = [
    {
      name: 'notificationtype',
      label: 'Notification Type',
      type: 'dropdown',
      required: true,
      options: [
        { label: 'All', value: 'All' },
        { label: 'State-Wise', value: 'State-Wise' },
        { label: 'Dealer-Wise', value: 'Dealer-Wise' },
      ],
      gridClass: 'col-lg-3',
      validation: {
        required: true,
      },
    },
    ...(formData?.notificationtype == 'State-Wise' ||
    formData?.notificationtype == 'Dealer-Wise'
      ? [
          {
            name: 'value_name',
            label: 'Value',
            type: 'dropdown',
            required: true,
            options:
              formData?.notificationtype == 'State-Wise'
                ? StateOptions
                : DealerOptions,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
    ...(formData?.notificationtype == 'All'
      ? [
          {
            name: 'defaultvalue',
            label: 'Value',
            type: 'text',
            required: true,
            disabled: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),

    {
      name: 'start_date',
      label: 'Start Date',
      type: 'date',
      required: true,
      minDate: new Date(),
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    {
      name: 'end_date',
      label: 'End Date',
      type: 'date',
      required: true,
      minDate: new Date(),
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    {
      name: 'notificationtitle',
      label: 'Title',
      type: 'text',
      placeholder: 'Enter Title',
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true, minLength: 3, maxLength: 50 },
    },

    {
      name: 'notification_desc',
      label: 'Description',
      placeholder: 'Enter Description',
      type: 'text',
      gridClass: 'col-lg-3',
      required: true,
      validation: validations.description({ required: true }),
    },
    {
      name: 'noti_image',
      label: 'Upload Notification Image',
      type: 'file',
      allowedExtensions: ['jpg', 'jpeg', 'png', 'pdf'],
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    {
      name: 'status',
      label: 'Status',
      type: 'toggle',
      required: true,
      gridClass: 'col-lg-7 ',
    },
  ];

  // const handleFormSubmit = async (formData) => {
  //   console.log("notificationformdata", formData);

  //   const errors = {};
  //   let isValid = true;

  //   NotificationInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       }
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   console.log("formData", formData);

  //   try {
  //     setIsLoading(true);
  //     const payload = {
  //       title: formData.notificationtitle,
  //       notificationType: formData.notificationtype,
  //       stateId:
  //         formData?.notificationtype == "State-Wise" ? formData?.value_name : 0,
  //       dealerId:
  //         formData?.notificationtype == "Dealer-Wise" ? formData?.value_name : 0,
  //       startDate: formData?.start_date,
  //       endDate: formData?.end_date,
  //       notiDescription: formData?.notification_desc,
  //       status: formData.status === true ? 1 : 0,
  //     };

  //     const confirmation = await Swal.fire({
  //       title: "Are you sure?",
  //       text: "Do you want to add this record?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Yes",
  //       cancelButtonText: "Cancel",
  //     });
  //     if (!confirmation.isConfirmed) {
  //       setIsLoading(false); // Reset loading state
  //       return;
  //     }
  //     const response = await axiosInstance.patch(
  //       `/notification/update/${notificationId}`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );
  //     Swal.fire({
  //       title: "Success!",
  //       text: "Notification updated successfully.",
  //       icon: "success",
  //       confirmButtonText: "OK",
  //     }).then(() => {
  //       navigate(ROUTES_NAVIGATION.NOTIFICATIONLIST);
  //     });
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     const errorMessage = error?.response?.data?.message;
  //     Swal.fire({
  //       title: "Error!",
  //       text: errorMessage
  //         ? errorMessage
  //         : "Failed to add the termset. Please try again.",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //     setIsLoading(false);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleFormSubmit = async (formData) => {
    console.log('notificationformdata', formData);

    const errors = {};
    let isValid = true;

    // Validate form fields
    NotificationInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = 'This field is required';
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    console.log('formData', formData);

    const formatDate = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    try {
      setIsLoading(true);

      // Create FormData instance for appending fields including image
      const newFormData = new FormData();
      newFormData.append('title', formData.notificationtitle);
      newFormData.append('notificationType', formData.notificationtype);
      newFormData.append(
        'stateId',
        formData?.notificationtype === 'State-Wise' ? formData?.value_name : 0,
      );
      newFormData.append(
        'dealerId',
        formData?.notificationtype === 'Dealer-Wise' ? formData?.value_name : 0,
      );
      // newFormData.append("startDate", formData?.start_date);
      // newFormData.append("endDate", formData?.end_date);

      newFormData.append('startDate', formatDate(formData?.start_date));
      newFormData.append('endDate', formatDate(formData?.end_date));

      newFormData.append('notiDescription', formData?.notification_desc);
      newFormData.append('status', formData.status === true ? 1 : 0);

      // Append image if it exists
      // if (formData.noti_image) {
      //   newFormData.append("noti_image", formData.noti_image);
      // }

      if (formData.noti_image) {
        if (formData.noti_image instanceof File) {
          // If it's a File object (user uploaded new image)
          newFormData.append('noti_image', formData.noti_image);
        } else if (typeof formData.noti_image === 'string') {
          // If it's a URL or path, fetch and convert to File
          const imageResponse = await fetch(formData.noti_image);
          const imageBlob = await imageResponse.blob();

          const fileName = formData.noti_image.split('/').pop(); // Extract filename from URL
          const imageFile = new File([imageBlob], fileName, {
            type: imageBlob.type,
          });

          newFormData.append('noti_image', imageFile);
        }
      }

      // Display confirmation dialog before proceeding
      const confirmation = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to update this record?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        setIsLoading(false); // Reset loading state
        return;
      }

      // Perform API call to submit form data
      const response = await axiosInstance.patch(
        `/notification/update/${notificationId}`,
        newFormData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      console.log('API Response:', response.data);

      // Success message after API call
      Swal.fire({
        title: 'Success!',
        text: 'Notification updated successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        navigate(ROUTES_NAVIGATION.NOTIFICATIONLIST);
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      const errorMessage = error?.response?.data?.message;
      Swal.fire({
        title: 'Error!',
        text: errorMessage
          ? errorMessage
          : 'Failed to update the notification. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false); // Always reset loading state
    }
  };

  return (
    <>
      <div className="backbutton mt-2 mb-2" >
        <img src={backicon} alt="back" onClick={() => navigate(-1)}/>
        <span className="backbtntitle">Set Notification</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Notification Details
        </span>
        <DynamicForm
          validateOnMount
          formConfig={NotificationInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          className="submit-btn"
          disabled={
            !isFormValid(NotificationInputs, formData, validationErrors) ||
            isLoading
          }
          style={buttonStyle(
            NotificationInputs,
            formData,
            validationErrors,
            isLoading,
          )}
          onClick={() => {
            if (!isFormSubmitted) {
              handleFormSubmit(formData);
            }
          }}
        >
          {isLoading ? 'Processing...' : 'Submit'}
        </button>
      </div>
    </>
  );
};

export default UpdateNotification;
